// Determine URL based on language code
export const getUrlForLanguage = (languageCode) => {
  switch (languageCode) {
    case 'ca':
    case 'es':
    case 'gl':
    case 'eu':
      return 'https://aulaabierta.arasaac.org/tutorial-caa-como-reconocer-las-claves-de-color-de-los-pictogramas'
    case 'fr':
      return 'https://aulaabierta.arasaac.org/en/tutorial-caa-how-to-recognize-the-keys-of-color-of-the-pictograms'
    case 'it':
      return 'https://aulaabierta.arasaac.org/it/tutorial-caa-come-riconoscere-le-chiavi-di-colore-dei-pittogrammi'
    case 'br':
    case 'pt':
      return 'https://aulaabierta.arasaac.org/pt-pt/tutorial-caa-reconhecer-as-chaves-da-cor-dos-pictogramas'
    default:
      return 'https://aulaabierta.arasaac.org/en/tutorial-caa-how-to-recognize-the-keys-of-color-of-the-pictograms'
  }
}
